import { useState, useRef, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'hooks';

// assets
import { IconLogout, IconSettings } from '@tabler/icons-react';

import { LOGOUT_ACTION } from 'store/rootReducer';
import apiClient from 'utils/apiClient';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const dispatch = useAppDispatch();
    const user = useAppSelector((state) => state.user);

    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        const handleEsc = (event) => {
            if (event.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEsc);
        };
    }, []);

    const handleLogout = () => {
        apiClient
            .post('/logout', { credentials: 'include' })
            .catch((error) => console.error(error))
            .finally(() => {
                dispatch({ type: LOGOUT_ACTION });
            });
    };

    return (
        <div className="gd-profile" ref={rootRef}>
            <button
                type="button"
                className="gd-profile__trigger"
                onClick={() => setOpen((prev) => !prev)}
                aria-haspopup="true"
                aria-expanded={open}
                aria-label="Account menu"
            >
                {user.info?.picture ? (
                    <img className="gd-profile__avatar" src={user.info.picture} alt="" />
                ) : (
                    <span className="gd-profile__avatar" />
                )}
                <IconSettings stroke={1.5} size={20} />
            </button>
            {open && (
                <div className="gd-profile__menu" role="menu">
                    <div className="gd-profile__header">
                        <div className="gd-profile__welcome">Welcome, {user.info?.fullName}</div>
                        <div className="gd-profile__authority">{user.info?.authority}</div>
                    </div>
                    <div className="gd-profile__divider" />
                    <button type="button" className="gd-profile__logout" onClick={handleLogout} role="menuitem">
                        <IconLogout stroke={1.5} size={20} />
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProfileSection;
